export default __webpack_public_path__ + "static/indoor18-30c540b37a7c962e6511bcfea0cbeb9f.webp";